import React from "react";
import { Row, Col } from "react-bootstrap";

const Maintenance = () => {
    return (
        <>
            <Row className='justify-content-center famsa-maintenance'>
                <Col md={{ span: 8 }} sm={{ span: 8 }}>
                    <h1 className="famsa-maintenance-h1 my-4 fw-bold">We’ll be back soon!</h1>
                </Col>
                <Col md={{ span: 8 }} sm={{ span: 8 }}>
                    <p className="famsa-maintenance-p my-4">Sorry for the inconvenience but we’re performing some maintenance at the moment. We’ll be back online shortly!</p>
                </Col>
                <Col md={{ span: 8 }} sm={{ span: 8 }}>
                    <p className="famsa-maintenance-p my-4">— The Team</p>
                </Col>
            </Row>
        </>
    );
}

export default Maintenance;